import { defined, definedNotNull, present } from 'shared/presenters/presenter'
import { Profit_And_Loss_Report } from 'shared/presenters/graphqlTypes'

export class AggregatedSchedulableBookingsPresenter extends present<Profit_And_Loss_Report>() {
  id = definedNotNull(this.schedulable_id)
  name = defined(this.product_name)
  createdAt = defined(this.created_at)
  reportingCode = defined(this.reporting_code)
  bookings = defined(this.count) ?? 0
  revenuePence = defined(this.revenue) ?? 0
  refundsPence = defined(this.refunds) ?? 0
  totalAttendees = defined(this.attendees) ?? 0
  averageCapacity = Math.floor((defined(this.average_capacity) ?? 0) * 100)
}
